import { render, staticRenderFns } from "./CreatePhaseStatusFormStep4.vue?vue&type=template&id=21169f9a&"
import script from "./CreatePhaseStatusFormStep4.vue?vue&type=script&lang=ts&"
export * from "./CreatePhaseStatusFormStep4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports